import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] bg-ivory flex items-center justify-center px-6 py-32">
      <div className="text-center max-w-md">
        <p className="font-serif text-6xl text-gold">404</p>
        <h1 className="mt-5 font-serif text-3xl text-navy">
          This page has moved on.
        </h1>
        <p className="mt-4 text-stone2 leading-relaxed">
          The link you followed doesn&rsquo;t lead anywhere — but the book is
          this way.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-8 inline-flex items-center justify-center bg-navy text-ivory px-7 py-3.5 rounded-full text-sm font-medium hover:bg-navy-light transition-colors"
        >
          Back to the beginning
        </Link>
      </div>
    </div>
  );
}
